import { useMemo, useState } from "react";
import Link from "next/link";
import { useTranslation } from "next-i18next";

const HIGHLIGHT_CLASS = "text-main-pink font-[700]";

const DEFAULT_ITEMS = [
  {
    title: "70% Maliyyə Dəstəyi",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
  {
    title: "2 Beynəlxalq Diplom",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
  {
    title: "Peer-to-Peer Metod",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
  {
    title: "AzTU Kampusunda",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
  {
    title: "İş Fürsətləri",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
  {
    title: "Güclü Portfolio",
    description: "NEQSOL Holding təhsil haqqının <highlight>70%-ni ödəyir</highlight>. Sən isə cəmi 30% ödəyirsən.",
  },
];

function renderHighlightedText(text = "") {
  return text.split(/(<highlight>.*?<\/highlight>)/g).map((part, index) => {
    const match = part.match(/^<highlight>(.*?)<\/highlight>$/);
    if (!match) return <span key={index}>{part}</span>;
    return (
      <span key={index} className={HIGHLIGHT_CLASS}>
        {match[1]}
      </span>
    );
  });
}

function AdvantageCard({ item }) {
  return (
    <article className="rounded-[12px] bg-[#091C63] py-[42px] px-[28px] border border-[#FFFFFF1A]">
      <h3 className="text-white text-[18px] font-[600] leading-[130%]">{item.title}</h3>
      <p className="mt-[8px] text-[#90A1B9] text-[14px] font-[400] leading-[150%]">
        {renderHighlightedText(item.description)}
      </p>
    </article>
  );
}

export default function SeoPageAdvantages({ seoPage }) {
  const { t } = useTranslation();
  const section = seoPage?.advantages_section ?? {};
  // API uses "cards"; fall back to legacy "items", then hardcoded defaults
  const items = section.cards?.length
    ? section.cards
    : section.items?.length
    ? section.items
    : DEFAULT_ITEMS;
  const [isExpanded, setIsExpanded] = useState(false);
  const mobileItems = useMemo(
    () => (isExpanded || items.length <= 3 ? items : items.slice(0, 3)),
    [isExpanded, items]
  );

  return (
    <section className="bg-[linear-gradient(180deg,#091F59_0%,#1A3884_100%)] py-[56px] md:py-[80px]">
      <div className="max-w-[90%] mx-auto">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex min-w-[140px] h-[28px] px-2 items-center justify-center rounded-full bg-[#DDECFF] text-[12px] font-[600] tracking-[0.08em] uppercase">
            <span className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884]">
              {section.label ?? section.badge ?? "ÜSTÜNLÜKLƏR"}
            </span>
          </span>

          <h2 className="mt-[12px] text-white text-[28px] md:text-[36px] font-[600] leading-[120%]">
            {section.title ?? "Niyə Peerstack Academy?"}
          </h2>

          <p className="mt-[12px] text-[#E5E7EB] text-[14px] md:text-[16px] leading-[140%] font-[400]">
            {section.description ?? section.subtitle ?? "Sadəcə bir kurs deyil — karyeranın başlanğıcı."}
          </p>
        </div>

        <div className="mt-[24px] md:hidden flex flex-col gap-[12px]">
          {mobileItems.map((item, index) => (
            <AdvantageCard key={`${item.title}-${index}`} item={item} />
          ))}

          {items.length > 3 && (
            <button
              type="button"
              onClick={() => setIsExpanded((prev) => !prev)}
              className="mt-[12px] h-[48px] w-full rounded-full border border-main-pink bg-main-pink text-white text-[16px] font-[500] transition duration-300 hover:bg-white hover:text-main-pink"
            >
              {isExpanded ? t("seo-page.show-less") : section.cta_text ?? t("seo-page.see-more")}
            </button>
          )}
        </div>

        <div className="mt-[32px] hidden md:grid md:grid-cols-2 xl:grid-cols-3 gap-[16px] md:gap-[20px] max-w-[75%] mx-auto">
          {items.map((item, index) => (
            <AdvantageCard key={`${item.title}-${index}`} item={item} />
          ))}
        </div>

        {section.cta_link && (
          <div className="hidden md:flex justify-center mt-[12px]">
            <Link href={section.cta_link}>
              <button className="h-[48px] min-w-[220px] px-[28px] rounded-full border border-main-pink bg-main-pink text-white text-[16px] font-[500] transition duration-300 hover:bg-white hover:text-main-pink">
                {section.cta_text ?? t("seo-page.see-more")}
              </button>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
